'use client';

import clsx from 'clsx';
import Link from 'next/link';
import { FC } from 'react';

interface BookDemoButtonProps {
  href?: string;
  className?: string;
  label?: string;
  onClick?: () => void;
  variant?: 'primary' | 'outline';
}

/** Matches Figma LP primary CTA — #0848E7, 170×50, rounded 4px */
export const BookDemoButton: FC<BookDemoButtonProps> = ({
  href = '/book-demo',
  className,
  label = 'Book Demo',
  onClick,
  variant = 'primary',
}) => {
  const base =
    'inline-flex items-center justify-center h-[50px] min-w-[170px] px-[29px] text-base font-medium transition-all duration-300 rounded-[4px]';

  const styles =
    variant === 'primary'
      ? 'bg-[#0848E7] text-white hover:bg-[#073dcc]'
      : 'border border-[#0848E7] text-[#0848E7] bg-white hover:bg-[#0848E7]/5';

  return (
    <Link href={href} className={clsx(base, styles, className)} onClick={onClick}>
      {label}
    </Link>
  );
};

export default BookDemoButton;
